import {
  TRIAGE_POSITIVE_ACTIVE_COLOR,
  TRIAGE_POSITIVE_MARKER_COLOR,
} from '../AssessmentIndex/AssessmentIndex.constants';
import { HIGH_NEED_TRIAGE_CATEGORY, WARNING_TRIAGE_STYLE } from './TriageHeader.constants';
import { TriageCategory } from './TriageHeader.types';

export const clampPercent = (value: number) => Math.max(0, Math.min(100, value));

export const getTriageCategory = ({
  persistenceIsLow,
  wellbeingIsLow,
}: {
  persistenceIsLow: boolean;
  wellbeingIsLow: boolean;
}): TriageCategory => {
  if (!persistenceIsLow && !wellbeingIsLow) {
    return {
      label: 'Thriving',
      activeColor: TRIAGE_POSITIVE_ACTIVE_COLOR,
      markerColor: TRIAGE_POSITIVE_MARKER_COLOR,
    };
  }

  if (!persistenceIsLow && wellbeingIsLow) {
    return { label: 'Strained', ...WARNING_TRIAGE_STYLE };
  }

  if (persistenceIsLow && !wellbeingIsLow) {
    return { label: 'Disengaged', ...WARNING_TRIAGE_STYLE };
  }

  return HIGH_NEED_TRIAGE_CATEGORY;
};
